module.exports = __webpack_public_path__ + "static/media/Pouť-95-MCoppa-9.1bcf7b17.jpg";